const getAddressComponent = (components, types) => {
    return components.find(c => types.every(t => c.types.includes(t)))?.long_name || '';
};

const buildAddressObject = components => {
    return {
        Line1: getAddressComponent(components, ['street_number']) + ' ' + getAddressComponent(components, ['route']),
        PostCode:
            getAddressComponent(components, ['postal_code']) ||
            getAddressComponent(components, ['postal_code_prefix']) ||
            getAddressComponent(components, ['premise']),
        City:
            getAddressComponent(components, ['locality']) ||
            getAddressComponent(components, ['sublocality']) ||
            getAddressComponent(components, ['administrative_area_level_2']),
        State: getAddressComponent(components, ['administrative_area_level_1']),
        Country: getAddressComponent(components, ['country'])
    };
};

export const latLangToAddress = (lat, lng) => {
    return new Promise((resolve, reject) => {
        if (typeof google === 'undefined' || !google.maps) {
            return reject('Google Maps API not loaded');
        }

        if (lat === null || lng === null) {
            return reject('Invalid latitude or longitude');
        }
        if (lat === 0 && lng === 0) {
            return resolve(undefined);
        }

        const geocoder = new google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status !== 'OK' || !results[0]) {
                console.error('Reverse geocode failed:', status);
                return reject(status);
            }

            const components = results[0].address_components;
            const address = buildAddressObject(components);
            resolve(address);
        });
    });
};
